import * as yup from 'yup';

const dutyLineCalculationSchema = yup.array().of(
  yup.object({
    value: yup.boolean().required(),
    groupId: yup.number().required(),
    settingId: yup.number().required(),
    key: yup.string().required()
  })
);

const decentralizedDutycodesSchema = yup.array().of(
  yup.object({
    value: yup.boolean().required(),
    groupId: yup.number().required(),
    settingId: yup.number().required(),
    key: yup.string().required()
  })
);

const defaultValuesSchema = yup.array().of(
  yup.object({
    value: yup.string().required(),
    groupId: yup.number().required(),
    settingId: yup.number().required(),
    key: yup.string().required()
  })
);

export const rosterSettingsSchema = yup.object({
  dutyLineCalculationSchema,
  decentralizedDutycodesSchema,
  defaultValuesSchema
});
